export default function (Vue, parent, _data) {
  var node_fork_join = {
    template: `
    <div class='__config__body'> 
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">
           <el-form label-width="65px">
            <el-form-item label="唯一标识：" v-show=false>
                <el-input v-model="data['id']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="节点名称：">
                <el-input v-model="data['name']" :disabled="!params.editable"></el-input>
            </el-form-item>
            <el-form-item label="节点序号：">
                <el-input v-model="data['sn']"></el-input>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="流程控制" name="2">
           <el-form label-width="65px">
            <el-form-item label="节点类型：">
                <el-select @change='changeType' v-model="data['type']" :disabled="!params.editable">
                  <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            
          </el-form>
        </el-collapse-item>
      </el-collapse>
      </div>
    `,
    props: {
      data: {
        type: Object
      },
      params:{
        type: Object
      }
    },
    data() {
      return {
        fields:['id','name','sn','type'],

        activeName: '1',
        types:[]
      };
    },
    created() {
      var me=this;
      me.clearField();
      me.types=me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function (val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", {id: me.data.id, name: val})
        }
      },
      'data.id': function (val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name
          this.$set(this.data, 'name', '新增聚合节点')
        }
        this.initData();
      }
    },
    methods: {
      initData(){
        var me = this;
        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增聚合节点')
        }
      },
      clearField:function(){
        var me=this;
        function contains(obj) {
          for(var i=0;i<me.fields.length;i++){
            if(me.fields[i]==obj){
              return true
            }
          }
          return false;
        }
        var del=[]
        for(var s in me.data){
          if(!contains(s)){
            del.push(s)
          }
        }
        for(var i=0;i<del.length;i++){
          delete me.data[del[i]]
        }
      },
      changeType:function(val){
        parent.$emit("updateShape", {id: this.data.id, type: val})
        this.params.changeType(val);
      }
    }

  }
  return node_fork_join
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/node_fork_join.js